module.exports = __webpack_public_path__ + "static/media/Cot.bde15e6f.jpg";